export { default } from "./CultureInfoTip";
